import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import './common/extensions/numberExtension';
import './common/extensions/stringExtension';
import Modal from 'react-modal';
import 'moment/locale/fr';
import 'moment/locale/pt';

require('dayjs/locale/pt')
require('dayjs/locale/fr')

dayjs.extend(utc);
dayjs.extend(timezone);

Modal.setAppElement('#root')

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
